// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fLu9","content":"styles_content__12YBY"};